"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _polished = require("polished");

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A simple component for displaying a progress bar 
 * @param {Object} progress The progress from 0 (min) to 100 (max)
 * @param {Object} barColor The colour of the progress bar
 * @param {Object} outlineColor The colour of the progress bar
 */
const getBarHeight = height => `${(0, _polished.getValueAndUnit)(height)[0] - 2}px`;

const ProgressBar = ({
  progress,
  barColor,
  outlineColor,
  height,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledProgressBar, {
  outlineColor: outlineColor,
  height: height,
  ...otherProps,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Bar, {
    className: "progress-bar-value",
    value: progress,
    color: barColor,
    height: getBarHeight(height)
  })
});

ProgressBar.propTypes = {
  progress: _propTypes.default.number,
  barColor: _propTypes.default.string,
  outlineColor: _propTypes.default.string,
  height: _propTypes.default.string,
  showTrack: _propTypes.default.bool
};
ProgressBar.defaultProps = {
  barColor: null,
  outlineColor: "#ffffff",
  height: "10px",
  showTrack: true,
  progress: 0
};
var _default = ProgressBar;
exports.default = _default;